import styled from '@emotion/styled';
import { css } from 'theme-ui';

export const TableBlock = styled.table(({ firstRowHeader }) =>
  css({
    borderCollapse: 'separate',
    borderSpacing: '0px',
    fontWeight: '400',
    color: 'text',

    'tr:nth-of-type(1)': {
      fontWeight: firstRowHeader && '700',
      fontSize: firstRowHeader && '18px',
      minHeight: firstRowHeader && '40px',
      td: {
        borderTop: '1px solid #ccc',
      },
    },
  }),
);

export const TableCell = styled.td(
  css({
    padding: '0 7px',
  }),
);

export const TableRow = styled.tr(({ firstColHeader }) =>
  css({
    'td:nth-of-type(1)': {
      fontWeight: firstColHeader && '700',
      fontSize: firstColHeader && '18px',
      minHeight: firstColHeader && '40px',
      borderLeft: '1px solid #ccc',
    },

    td: {
      borderBottom: '1px solid #ccc',
      borderRight: '1px solid #ccc',
    },

    'td.htLeft': { textAlign: 'left' },
    'td.htCenter': { textAlign: 'center' },
    'td.htRight': { textAlign: 'right' },
    'td.htJustify': { textAlign: 'justify' },
    'td.htTop': { verticalAlign: 'top' },
    'td.htMiddle': { verticalAlign: 'middle' },
    'td.htBottom': { verticalAlign: 'bottom' },
  }),
);
